/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_Li4_DescInputs */

const tr_iade_iptal_s11_li4_desc = /** @type {(inputs: Iade_Iptal_S11_Li4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri döndürülemez şekilde, ilgili Aboneyle eşleştirilemeyecek hale getirme; KVKK Madde 7/2 ve Kişisel Verileri Silme, Yok Etme veya Anonim Hale Getirme Yönetmeliği uyarınca yapılır.`)
};

const en_iade_iptal_s11_li4_desc = /** @type {(inputs: Iade_Iptal_S11_Li4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering data irreversibly incapable of being matched with the relevant Subscriber; carried out pursuant to KVKK Madde 7/2 and the Kişisel Verileri Silme, Yok Etme veya Anonim Hale Getirme Yönetmeliği.`)
};

const de_iade_iptal_s11_li4_desc = /** @type {(inputs: Iade_Iptal_S11_Li4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unumkehrbare Umwandlung in einen Zustand, in dem keine Zuordnung zum betreffenden Abonnenten mehr möglich ist; erfolgt gemäß KVKK Madde 7/2 und der Kişisel Verileri Silme, Yok Etme veya Anonim Hale Getirme Yönetmeliği.`)
};

const ru_iade_iptal_s11_li4_desc = /** @type {(inputs: Iade_Iptal_S11_Li4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необратимое приведение данных в состояние, при котором их невозможно сопоставить с соответствующим Абонентом; осуществляется согласно KVKK Madde 7/2 и Kişisel Verileri Silme, Yok Etme veya Anonim Hale Getirme Yönetmeliği.`)
};

/**
* | output |
* | --- |
* | "Rendering data irreversibly incapable of being matched with the relevant Subscriber; carried out pursuant to KVKK Madde 7/2 and the Kişisel Verileri Silme, Y..." |
*
* @param {Iade_Iptal_S11_Li4_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_li4_desc = /** @type {((inputs?: Iade_Iptal_S11_Li4_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_Li4_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_li4_desc(inputs)
	if (locale === "de") return de_iade_iptal_s11_li4_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_li4_desc(inputs)
	return tr_iade_iptal_s11_li4_desc(inputs)
});